module.exports = __webpack_public_path__ + "static/media/get_paid.e23468aa.svg";